'use client';

import { useState } from 'react';
import { type NodeProps } from '@xyflow/react';
import { NodeShell } from '../BaseNode';
import { usePipelineStore } from '@/lib/pipeline/store';
import GalleryPickerModal from '../GalleryPickerModal';
import { ParamNameField } from '../ParamNameField';
import { api } from '@/lib/api';
import { JobResponse } from '@/lib/types';

export default function ImageGalleryNode({ id, data }: NodeProps) {
  const update = usePipelineStore((s) => s.updateNodeData);
  const [open, setOpen] = useState(false);
  const d = data as { thumbUrl?: string | null; param?: string | null };

  const onPick = (job: JobResponse) => {
    const fn = job.images[0];
    update(id, {
      filename: fn,
      imageUrl: api.getImageUrl(fn),
      thumbUrl: api.getThumbnailUrl(fn),
    });
    setOpen(false);
  };

  return (
    <NodeShell id={id} type="imageGallery">
      {d.thumbUrl ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={d.thumbUrl} alt="selected" className="rounded-lg w-full" />
      ) : (
        <div className="text-xs text-[var(--text-muted)] py-6 text-center border border-dashed border-[var(--border-subtle)] rounded-lg">
          No image
        </div>
      )}
      <button
        onClick={() => setOpen(true)}
        className="btn btn-ghost nodrag w-full text-xs h-8 mt-1"
      >
        {d.thumbUrl ? 'Change' : 'Pick from gallery'}
      </button>
      <ParamNameField id={id} value={d.param} />
      {open && <GalleryPickerModal onSelect={onPick} onClose={() => setOpen(false)} />}
    </NodeShell>
  );
}
